import { ClientWalletRolesMap } from '@tassat/common-definitions';
import { browserSessionStore } from '@tassat/utility';

import { download } from 'Lib/exportHelper';
import { AssetBalanceColumnDef, buildAssetBalanceColumnDefs, getAssetBalanceColumnValues } from 'Lib/exports/assetBalanceColumnsHelper';
import { obscureAccountNo } from 'Lib/stringHelpers';
import ClientStore from 'Reducers/store/clientStore';
import { getAllAssetsByCurCodeAndPriceArray } from 'Selectors/assets';
import { getMappedUserAccountsByUserIdClient } from 'Selectors/userAccounts';

export const exportClientAccountsData = () => {
    const store = ClientStore.getState();
    const userWallets = getMappedUserAccountsByUserIdClient(store, browserSessionStore.getItem('userid'), undefined, false, false);

    const currencyGroups = getAllAssetsByCurCodeAndPriceArray(store);
    const assetBalancesColumnDefs: AssetBalanceColumnDef[] = buildAssetBalanceColumnDefs(currencyGroups);

    const assetBalancesColumnsHeader = assetBalancesColumnDefs
        .map(({ header }) => header)
        .join(',');

    let exportString = `Account Name,Account Address,Linked BD Account Number,Role,Locked Status,${assetBalancesColumnsHeader}\n`;

    userWallets.forEach(mappedWallet => {
        const assetBalancesColumnsValues = getAssetBalanceColumnValues(store, mappedWallet.account.AccountId, assetBalancesColumnDefs);
        const myRole = (ClientWalletRolesMap.find(role => role.id === mappedWallet.userAccount.ClientRoleId) || {}).displayName;
        const obscuredWallet = mappedWallet.account.AccountName ? `S${mappedWallet.account.Account.slice(2)}` : '';

        const cellValues = [
            `"${mappedWallet.account.AccountName}"`,
            `"${obscuredWallet}"`,
            `"${obscureAccountNo((mappedWallet.account as any).linkedBrokerDealerAccount)}"`,
            `"${myRole}"`,
            `"${mappedWallet.account.IsLocked}"`,
            ...assetBalancesColumnsValues
        ].join(',');

        exportString += `${cellValues}\n`;
    });

    download('Lynq_Platform_Accounts.csv', exportString);
};